import React from 'react';

import { Footer, Header, PageLayout } from '../../components';
import PageContent from '../../features/Users';
import { useAuthValidation } from '../../utils/hooks';

const UsersPage = () => {
  useAuthValidation();

  return (
    <>
      <Header />
      <PageLayout>
        <PageContent />
      </PageLayout>
      <Footer />
    </>
  );
};

export default UsersPage;
